import { render, staticRenderFns } from "./SupplierAfterSalesPanel.vue?vue&type=template&id=a19ddf6c&scoped=true"
import script from "./SupplierAfterSalesPanel.vue?vue&type=script&lang=js"
export * from "./SupplierAfterSalesPanel.vue?vue&type=script&lang=js"
import style0 from "./SupplierAfterSalesPanel.vue?vue&type=style&index=0&id=a19ddf6c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19ddf6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a19ddf6c')) {
      api.createRecord('a19ddf6c', component.options)
    } else {
      api.reload('a19ddf6c', component.options)
    }
    module.hot.accept("./SupplierAfterSalesPanel.vue?vue&type=template&id=a19ddf6c&scoped=true", function () {
      api.rerender('a19ddf6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/SupplierAfterSalesPanel.vue"
export default component.exports